@if (project$ | async; as project) {
  @if (menuGroups$ | async; as menuGroups) {
    <div class="project-main">
      <div class="project-menu">
        @for (menuPositions of menuGroups; track $index) {
          @for (menu of menuPositions; track $index) {
            @if (!menu.hidden) {
              <span [matTooltip]="menu.tooltip || menu.name" [matTooltipPosition]="'right'">
                <button
                  mat-icon-button
                  [attr.data-testid]="'project-menu-' + (menu.name | cssclass)"
                  [attr.data-guide]="menu.path === 'tracker' ? 'tracker-menu' : null"
                  (click)="refreshDiscrepancies(); registerMatomoSelectMenu(menu.name)"
                  [disableRipple]="true"
                  class="menu-item"
                  [routerLink]="'/project/' + project.id + '/' + menu.path"
                  routerLinkActive="active"
                  [matBadge]="menu.badge"
                  [disabled]="menu.disabled">
                  @if (menu.svgIcon) {
                    <mat-icon [svgIcon]="menu.icon"></mat-icon>
                  } @else {
                    <mat-icon class="material-icons-outlined" inline>{{ menu.icon }}</mat-icon>
                  }
                </button>
              </span>
            }
          }
          @if (!$last && hasVisibleMenu(menuPositions)) {
            <div class="separator"></div>
          }
        }
      </div>
      @if (secondaryMenu$ | async; as secondaryMenu) {
        <div class="project-menu-secondary">
          <div class="project-menu-title">
            {{ secondaryMenu.name }}
          </div>
          @for (menu of secondaryMenu.items; track $index) {
            @if (!menu.hidden) {
              <a
                class="submenu-item"
                [routerLink]="'/project/' + project.id + '/' + menu.path"
                routerLinkActive="active"
                [attr.data-testid]="'project-submenu-' + (menu.name | cssclass)">
                {{ menu.name }}
              </a>
            }
          }
        </div>
      }

      <div class="project-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  }
}
